export function downloadPDF(url = '', filename = '', method = '', token = '', callback?: Function) {
	const xhr = new XMLHttpRequest();
	xhr.open(method, url, true);
	xhr.setRequestHeader('Authorization', `Bearer ${token}`);
	xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	xhr.responseType = 'arraybuffer';
	xhr.onload = function () {
		if (this.status === 200) {
			const blob = new Blob([this.response], { type: 'application/pdf' });
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = filename;
			link.click();
			if (callback) {
				callback();
			}
		}
	};
	xhr.send();
}
